export default __webpack_public_path__ + "ffff84ee31150bfa91e67c5f30463501.png";